import { useInfiniteQuery, useMutation, useQuery } from 'react-query';

import { useServiceError } from '@/hooks';
import {
  createQuizzes,
  detailQuizzes,
  editQuizzes,
  listQuizzes,
  removeQuizzes,
} from './Quizzes.service';
import {
  CreatQuizzesData,
  EditQuizzesData,
  ListQuizzesParams,
} from './Quizzes.types';
import notificationError from '@/utils/functions/notificationError';

import { DEFAULT_ORDER, DEFAULT_ROWS } from '..';

export function useListQuizzes(params?: ListQuizzesParams) {
  const query = useInfiniteQuery(
    ['quizzes', { ...params }],
    ({ pageParam }) => {
      const req: ListQuizzesParams = {
        nextToken: pageParam,
        order: params?.order || DEFAULT_ORDER,
        rows: params?.rows || DEFAULT_ROWS,
        ...params,
      };

      return listQuizzes(req);
    },
    {
      getNextPageParam: (lastPage) => lastPage.nextToken,
    },
  );

  useServiceError(query.error);

  return query;
}

export function useDetailQuizzes(id?: number) {
  return useQuery(['quizzes/detail', id], () => detailQuizzes(id), {
    enabled: !!id,
    onError(error) {
      notificationError(error);
    },
  });
}

export function useCreateQuizzes() {
  const mutation = useMutation((obj: CreatQuizzesData) => createQuizzes(obj));

  useServiceError(mutation.error);

  return mutation;
}

export function useEditQuizzes(quizId: number) {
  const mutation = useMutation((obj: EditQuizzesData) =>
    editQuizzes(quizId, obj),
  );

  useServiceError(mutation.error);

  return mutation;
}

export function useRemoveQuizzes() {
  const mutation = useMutation((id: number) => removeQuizzes(id), {
    onError(error) {
      notificationError(error, {
        translate: (errors) =>
          errors.map((err) =>
            err.includes('Quiz Referential integrity constraint violation')
              ? 'Este questionário está vinculado com alguma opção de envio.'
              : err,
          ),
      });
    },
  });

  return mutation;
}
